import { call, put, takeLatest } from "redux-saga/effects";
import { DefectivePartType } from "./actionTypes";
import { API } from "src/util/api";
import { geDefectivePartListSuccess, geLocationForDefectivePartSuccess, getDefectivePartListError, getLocationForDefectivePartError } from "./actions";

function* getDefectivePartListAsync(action: any) {
    try {
      const response: Promise<any> = yield call(API.getDefectivePartListAPI, { ...action.lazyState })
      yield put(geDefectivePartListSuccess(response))
    }
    catch (error) {
      yield put(getDefectivePartListError(error))
    }
  }

function* getLocationForDefectivePartAsync() {
  debugger
    try {
      const response: Promise<any> = yield call(API.getDefectivePartLocationAPI)
      yield put(geLocationForDefectivePartSuccess(response))
    }
    catch (error) {
      yield put(getLocationForDefectivePartError(error))
    }
  }

  
function* defectivePartSaga() {
    yield takeLatest(DefectivePartType.GET_DEFECTIVE_PART_LIST_LOADING, getDefectivePartListAsync);
    yield takeLatest(DefectivePartType.GET_LOCATION_FOR_DEFECTIVE_PART_LOADING, getLocationForDefectivePartAsync);
  }
  
  export default defectivePartSaga